<template>
  <div class="page-header">
    <h1>Housing Summary</h1>
  </div>
  <BaseDropdown
    v-model="selectedTerm"
    div-style="width: fit-content"
    label="Term"
    class="mb-3"
    :options="terms.map((x) => x.name)"
    name="termSteps"
    :disabled="terms.length === 1"
  />
  <div class="card">
    <div class="card-body">
      <ul>
        <li
          v-for="step in currentSteps.steps"
          :key="step.name"
          :class="{ completed: step.completed }"
        >
          <span v-if="step.completed">
            <i class="bi bi-check-square"></i>
          </span>
          <span v-else>
            <i class="bi bi-square"></i>
          </span>

          <a v-if="step.url" :href="step.url"> {{ step.name }}</a>
          <span v-else> {{ step.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

type Steps = { name: string; completed: boolean; url: string }[];

type Props = {
  defaultSelection: string;
  termNames: string[];
  terms: {
    steps: Steps;
    name: string;
  }[];
};

const props = defineProps<Props>();

const selectedTerm = ref(props.defaultSelection);

const currentSteps = computed(() =>
  props.terms.find((x) => x.name === selectedTerm.value)
);
</script>
